import React from 'react';
import { cn } from '../lib/utils';
interface WaveformDividerProps {
  className?: string;
}
export function WaveformDivider({
  className
}: WaveformDividerProps) {
  return <div className={cn('w-full flex justify-center py-12 opacity-20', className)} aria-hidden="true" data-id="element-63">
      <svg width="100%" height="40" viewBox="0 0 1200 40" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-coral" data-id="element-64">
        <path d="M0 20 Q 150 0, 300 20 T 600 20 T 900 20 T 1200 20" stroke="currentColor" strokeWidth="1" fill="none" className="breathe" data-id="element-65" />
        <path d="M0 20 Q 150 40, 300 20 T 600 20 T 900 20 T 1200 20" stroke="currentColor" strokeWidth="0.5" fill="none" className="breathe" style={{
        animationDelay: '2s'
      }} data-id="element-66" />
      </svg>
    </div>;
}